export default "__VITE_ASSET__Bkxl4uwS__"